export enum DateType {
  INACTIVE,
  ACTIVE,
  HOLIDAY,
  SUSPENDED,
  NO_DATA
}
